export interface IMocks {
  url: string;
  params?: any;
  // по-умолчанию 200
  httpCode?: number;
  json?: string;
}

export const mocks: IMocks[] = [
  // {
  //   url: '/auth/sign-in/basic',
  //   json: 'login',
  //   params: {
  //     username: 'admin',
  //     password: 'admin',
  //   },
  // },
  // {
  //   url: '/auth/session/refresh',
  //   json: 'refresh',
  // },
  // {
  //   url: '/auth/groups/search',
  //   json: 'group-search',
  // },
  // {
  //   url: '/auth/users/search',
  //   json: 'user-search',
  // },
  // {
  //   url: '/analytics',
  //   json: 'students-analytics-geography',
  //   params: {
  //     disciplineIds: [56],
  //   },
  // },
  // {
  //   url: '/analytics',
  //   json: 'students-analytics-math',
  //   params: {
  //     disciplineIds: [1],
  //   },
  // },
  // {
  //   url: '/analytics',
  //   json: 'students-analytics-geography-math',
  //   params: {
  //     disciplineIds: [1, 56],
  //   },
  // },
  // {
  //   url: '/disciplines/by-semester/1',
  //   json: 'disciplines-by-semester',
  // },
  // {
  //   url: '/semesters/current',
  //   json: 'semester',
  // },
  // {
  //   url: '/disciplines/1',
  //   json: 'disciplines1',
  // },
  // {
  //   url: '/disciplines/2',
  //   json: 'disciplines2',
  // },
  // {
  //   url: '/disciplines/3',
  //   json: 'disciplines3',
  // },
  // {
  //   url: '/disciplines/56',
  //   json: 'disciplines1',
  // },
  // {
  //   url: '/disciplines/9808',
  //   json: 'disciplines2',
  // },
  // {
  //   url: '/disciplines/5',
  //   json: 'disciplines3',
  // },
  // {
  //   url: '/disciplines/6',
  //   json: 'disciplines1',
  // },
  // {
  //   url: '/disciplines/7',
  //   json: 'disciplines2',
  // },
  // {
  //   url: '/disciplines/8',
  //   json: 'disciplines3',
  // },
  // {
  //   url: '/disciplines/9',
  //   json: 'disciplines1',
  // },
  // {
  //   url: '/disciplines/10',
  //   json: 'disciplines2',
  // },
  // {
  //   url: '/disciplines/11',
  //   json: 'disciplines3',
  // },
  // {
  //   url: '/timetables/me',
  //   json: 'timetableday',
  // },
  // {
  //   url: '/timetables/1',
  //   json: 'timetable',
  // },
  // {
  //   url: '/lessons/me/by-date/2026-06-23',
  //   json: 'lessons-today',
  // },
  // {
  //   url: '/lessons/me/by-date/2026-06-24',
  //   json: 'lessons-tomorrow',
  // },
  // {
  //   url: '/disciplines',
  //   json: 'error',
  //   httpCode: 422,
  // },
];
